// eslint-disable-next-line max-len
import { LaboratorySpecificSetting } from 'src/app/modules/admin/components/shared/components/laboratory-specific-settings/models/laboratory-specific-setting.model';
import { PluginFileSettingWithContent } from 'src/app/services/dtos/pluginFileSettingWithContent';
import { PluginWithSettings } from 'src/app/services/dtos/pluginWithSettings';

export class FetchAllPluginsBasicInfo {
  public static readonly type = '[Plugins] Fetch All Basic Info';
}

export class FetchPluginsForCustomer {
  public static readonly type = '[Plugins] Fetch All Plugins For Customer';
  public constructor(public id: string) {}
}

export class FetchPlugin {
  public static readonly type = '[Plugins] Fetch';
  public constructor(public id: string) {}
}

export class SetCurrentPluginId {
  public static readonly type = '[Plugins] Set Current Plugin Id';
  public constructor(public id: string) {}
}

export class ClearCurrentPluginId {
  public static readonly type = '[Plugins] Clear Current Plugin Id';
}

export class StartPlugin {
  public static readonly type = '[Plugins] Start';
  public constructor(public id: string) {}
}

export class StopPlugin {
  public static readonly type = '[Plugins] Stop';
  public constructor(public id: string) {}
}

export class EnablePluginTestMode {
  public static readonly type = '[Plugins] Enable Test Mode';
  public constructor(public id: string) {}
}

export class LoadPluginLibrary {
  public static readonly type = '[Plugins] Load Plugin Library';
  public constructor(public fileToUpload: File) {}
}

export class UpdatePlugin {
  public static readonly type = '[Plugins] Update';
  public constructor(public payload: PluginWithSettings) {}
}

export class UpdatePluginConfigurationFile {
  public static readonly type = '[Plugins] Update Plugin Configuration File';
  public constructor(
    public pluginId: string,
    public payload: PluginFileSettingWithContent
  ) {}
}

export class DeletePlugin {
  public static readonly type = '[Plugins] Delete';
  public constructor(public id: string) {}
}

export class AddPluginLaboratorySpecificSetting {
  public static readonly type =
    '[Plugins] Add Plugin Laboratory Specific Setting';
  public constructor(public payload: LaboratorySpecificSetting) {}
}

export class UpdatePluginLaboratorySpecificSetting {
  public static readonly type =
    '[Plugins] Update Plugin Laboratory Specific Setting';
  public constructor(public settingId: string, public payload: LaboratorySpecificSetting) {}
}

export class DeletePluginLaboratorySpecificSetting {
  public static readonly type =
    '[Plugins] Delete Plugin Laboratory Specific Setting';
  public constructor(public pluginId: string, public settingId: string) {}
}
